import {types, flow} from 'mobx-state-tree';
import PromoteListingModel from '../PromoteListingModel';
import {PromoteListingModelType} from '../PromoteListingModel';
import PaginationModel from '../PaginationModel';
import * as api from '../../services/api';

const PromoteListingListModel = types
  .model('PromoteListingListModel', {
    isLoading: types.optional(types.boolean, false),
    entries: types.map(PromoteListingModel),
    pagination: types.optional(PaginationModel, {})
  })
  .actions(self => ({
    loadEntries: flow(function*(
      userId: number,
      limit: number,
      offset: number
    ) {
      self.isLoading = true;
      const response = yield api.getPromoteListings(userId, limit, offset);
      if (response && response.data) {
        const entries = response.data.listings;
        if (!entries || entries.length === 0) {
          return;
        }

        const received = entries.reduce(
          (
            results: {[id: string]: PromoteListingModelType},
            r: PromoteListingModelType
          ) => {
            results[String(r.id)] = r;
            return results;
          },
          {}
        );

        self.entries.merge(received);
      }
      self.isLoading = false;
    }),
    deleteListing: flow(function*(listingId: number) {
      const response = yield api.deletePromoteListing(listingId);
      if (response && response.status === 200) {
        self.entries.delete(String(listingId));
      }
    })
  }));

export type PromoteListingListModelType = typeof PromoteListingListModel.Type;
export default PromoteListingListModel;



// WEBPACK FOOTER //
// ./src/models/PromoteListingListModel/PromoteListingListModel.ts